import React, { useState } from 'react'
import './Login.css';
import axios from 'axios';
import { environment } from '../../environment';

const Login = () => {
  const [data, setData] = useState({
    email: "",
    password: "",
});
const [passwordType, setPasswordType] = useState("password");
const [passwordInput, setPasswordInput] = useState("");
const [loading, setLoading] = useState(false);

const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value })
}

const handlePasswordChange =(evnt)=>{
  setPasswordInput(evnt.target.value);
}

  const handleSubmit = async (e) => {
    try {
      setLoading(true);
      e.preventDefault();
      const url = `${environment.LOCALHOST_URL}/auth/login`;
      const { data: res } = await axios.post(url, data);
      console.log({data})
      localStorage.setItem('token', res.data);
      localStorage.setItem('message', res.message);
      setLoading(false);


      window.location = '/terminacc';
      
    } catch (error) {
      window.location = '/';
            
    }
}

  return (
    <div className='main-login container'>
      <form className="Auth-form">
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Identifikohu</h3>
          

          <div className="form-group mt-3">
            <label>Email </label>
              <input
                type="text"
                placeholder='  Email'
                name='email'
                onChange={handleChange}
                value={data.email}
                required
                className='form-control'

              />
          </div>

          <div className="form-group mt-3">
            <label>Password</label>
              <input
                type="text"
                className='form-control'
                placeholder='  Password'
                name='password'
                onChange={handleChange}
                value={data.password}
                required
                
              />
          </div>

          <div className="d-grid gap-2 mt-3">
            <button type='submit' onClick={handleSubmit} className="button-black">
              LOGIN
              {
                loading === true ? <div className="spinner-border" style={{float: 'right'}} role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              :
              ""
              }
            </button>
          </div>

          <p className="forgot-password text-right mt-2">
            <a href="/auth/signup">Nuk jeni te regjistruar? Kliko ketu per tu regjistruar</a>
          </p>
        </div>
    

      </form>



    </div>
  )
}

export default Login;
